import { render, staticRenderFns } from "./TeamTickets.vue?vue&type=template&id=19f8dce6&"
import script from "./TeamTickets.vue?vue&type=script&lang=js&"
export * from "./TeamTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
})
